import api from '../api';

// Utils
import { normalizeUrl } from '../../utils/url';

// import { mockTable } from '../../mocks/mock-table';
/**
 * Get table data from an endpoint
 * @param {string} path - The path of the page
 * @param {{pageNumber: number}} [params = { pageNumber: 1 }] - The query params
 * @param {string | null} [contexte] - The context (optional)
 * @returns {Promise<ApiManagerTableResponse>} The table data
 */
export const getTableData = async (path, params = { pageNumber: 1 }, contexte = null) => {
  const contexteParam = contexte ? `&contexte=${contexte}` : '';
  const response = await api.get(`/table?pageNumber=${params.pageNumber}&path=${path}${contexteParam}`);
  return response.data;
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 1000);
  // });
  // return mockTable;
};

/**
 * Delete a table row
 * @param {string} url - The url to delete the row
 * @returns {Promise<boolean>} The result of the deletion
 */
export const deleteTableRow = async (url) => {
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 1000);
  // });
  const response = await api.post(url);
  return response.data;
  // return true;
};

/**
 * Call the reload table action URL (GET).
 * Used by row action "reloadTable" to trigger server-side logic then refresh table data.
 * @param {string} actionUrl - The URL to call for reloading the table
 * @returns {Promise<unknown>} The response data
 */
export const callReloadTableAction = async (actionUrl) => {
  const response = await api.post(normalizeUrl(actionUrl));
  return response.data;
};
